(() => {
  const root = document.documentElement;

  // Ne rien faire si pas de markup promo sur la page
  if (!document.querySelector("[data-vx-promo]")) return;

  const settings = window.promoSettings;
  if (!settings?.enabled) return;
  

  const CACHE_KEY = "vx_state";
  const GET_VISITOR = "/apps/laberge/api/get_visitor";
  const ADD_VISITOR = "/apps/laberge/api/add_visitor"; 
  const SUBSCRIBE_VISITOR = "/apps/laberge/api/subscribe_visitor";

  const CART_ATTR_KEY = "vx_promo";
  const CART_UPDATE_URL = "/cart/update.js";
  const STATE_ATTR = "data-vx-state";

  const LIVE_MODE = settings.vx_state_live ?? "promo"; // "auto" | "promo" | "evergreen"


  // ✅ on garde le fp en mémoire pour pouvoir update le cache au moment où le countdown expire
  let CURRENT_FP_ID = null;

  // function pushFirstVisitEvent(firstVisitISO) {
  //   try {
  //     const elapsed = Date.now() - new Date(firstVisitISO).getTime();
  //     const within72h = elapsed < 72 * 60 * 60 * 1000;
  //     const sent = sessionStorage.getItem("vx_72h_sent");
      
  //     window.dataLayer = window.dataLayer || [];
  //     if (within72h && !sent) {
  //       window.dataLayer.push({ event: "first_visit_72h" });
  //       sessionStorage.setItem("vx_72h_sent", "1");
  //     }
  //     else if (!within72h && sent === "1") {
  //       window.dataLayer.push({ event: "first_visit_72h_remove" });
  //       sessionStorage.setItem("vx_72h_sent", "removed");
  //     }
  //   } catch {}
  // }
  // function pushFirstVisitEvent() {
  //   try {
  //     const KEY = "vx_first_visit_sent"; // clé unique

  //     // déjà envoyé une fois ? on stop
  //     if (localStorage.getItem(KEY) === "1") return;

  //     window.dataLayer = window.dataLayer || [];
  //     window.dataLayer.push({ event: "first_visit_72h" });

  //     // marque comme envoyé définitivement
  //     localStorage.setItem(KEY, "1");
  //   } catch {}
  // }
  function setCookie(name, value, expiresISO) {
    const expires = new Date(expiresISO).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function computeExpiry(firstVisitISO, duration) {
    const first = new Date(firstVisitISO);
    if (Number.isNaN(first.getTime())) throw new Error("firstVisit invalid");

    const localMidnightOf = (d) =>
      new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);

    if (duration === "midnight") {
      const hour = first.getHours();
      const daysToAdd = hour >= 22 ? 2 : 1;
      const exp = localMidnightOf(first);
      exp.setDate(exp.getDate() + daysToAdd);
      return exp;
    }

    const hours = Number(duration);
    if (!Number.isFinite(hours) || hours <= 0) {
      throw new Error("duration must be 'midnight' or a positive number");
    }

    return new Date(first.getTime() + hours * 60 * 60 * 1000);
  }

  function getPromoStatus(firstVisitISO, duration, nowMs = Date.now()) {
    const expiresAt = computeExpiry(firstVisitISO, duration);
    const expiresMs = expiresAt.getTime();
    const expired = expiresMs <= nowMs;

    return {
      expired,
      state: expired ? "evergreen" : "promo",
      expiresAtISO: expiresAt.toISOString(),
      expiresMs,
    };
  }

  function getCurrentState() {
    return root.getAttribute(STATE_ATTR) || "";
  }

  function setState(state) {
    root.setAttribute(STATE_ATTR, state);
  }

  function readCache(fpId) {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data || data.fpId !== fpId) return null;
      return data;
    } catch {
      return null;
    }
  }

  function writeCache(data) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
    } catch {}
  }

  async function getFingerprint() {
    if (!window.FingerprintJS) return null;
    try {
      const fp = await FingerprintJS.load();
      const res = await fp.get();
      return res?.visitorId || null;
    } catch {
      return null;
    }
  }

  async function fetchVisitor(fpId) {
    try {
      const url = `${GET_VISITOR}?fingerprint=${encodeURIComponent(fpId)}`;
      const r = await fetch(url, { method: "GET", credentials: "same-origin" });
      if (!r.ok) return null;
      return await r.json();
    } catch {
      return null;
    }
  }

  async function createVisitor(fpId, firstVisitAtISO, expiresAtISO) {
    try {
      const r = await fetch(ADD_VISITOR, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          fingerprint: fpId,
          firstVisitAt: firstVisitAtISO,
          expiresAt: expiresAtISO,
        }),
      });

      if (!r.ok) return false;

      const j = await r.json().catch(() => ({}));
      return j?.ok !== false;
    } catch {
      return false;
    }
  }

  async function subscribeVisitor(fpId) {
    try {
      const r = await fetch(SUBSCRIBE_VISITOR, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ fingerprint: fpId }),
      });

      if (!r.ok) return false;

      const j = await r.json().catch(() => ({}));
      return j?.ok !== false;
    } catch {
      return false;
    }
  }

  // Performance:
  // - 1 seule requête /cart/update.js max quand l'état change
  // - jamais de polling
  // - on mémorise le dernier état sync dans sessionStorage
  const SYNC_KEY = "vx_cart_attr_synced_state";

  async function syncCartAttrIfNeeded(nextState) {
    try {
      const last = sessionStorage.getItem(SYNC_KEY) || "";
      if (last === nextState) return; // déjà sync dans cette session

      // Si l'attribut est déjà dans le cart d'avant, on veut le nettoyer quand evergreen.
      // On ne fait l'appel que si changement d'état.
      const value = nextState === "promo" ? "1" : null;

      await fetch(CART_UPDATE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          attributes: {
            [CART_ATTR_KEY]: value,
          },
        }),
      }).catch(() => {});

      sessionStorage.setItem(SYNC_KEY, nextState);
    } catch {}
  }

  function dispatchCountdown(expiresAtISO) {
    document.dispatchEvent(
      new CustomEvent("vx:countdown", { detail: { expiresAtISO } })
    );
  }
  function dispatchVisitorReady() {
    document.dispatchEvent(
      new CustomEvent("vx:visitor", { detail: { timestamp: Date.now() } })
    );
  }
  async function applyStateAndSideEffects(status, firstVisitAt = null) {
    const current = getCurrentState();
    if (current !== status.state) setState(status.state);

    await syncCartAttrIfNeeded(status.state);

    // if (firstVisitAt) pushFirstVisitEvent();
    if (status.state === "promo") dispatchCountdown(status.expiresAtISO);
  }

  // ✅ Quand le countdown dit "expired", on force evergreen (sans polling)
  document.addEventListener("vx:promo-expired", (e) => {
  try {
    if (getCurrentState() === "evergreen") return;

    // Si on est en mode forcé promo → on relance 72h au lieu de passer evergreen
    // if (LIVE_MODE === "promo") {
    //   const FORCED_KEY = "vx_forced_promo";
    //   const DURATION_H = 72;
    //   const newExpiresAt = new Date(Date.now() + DURATION_H * 60 * 60 * 1000).toISOString();
    //   try {
    //     localStorage.setItem(FORCED_KEY, JSON.stringify({ expiresAt: newExpiresAt }));
    //   } catch {}
    //   // L'état reste "promo", on relance juste le countdown
    //   dispatchCountdown(newExpiresAt);
    //   return;
    // }
    if (LIVE_MODE === "promo") {
      const COOKIE_NAME = "vx_forced_promo";
      const DURATION_RENEW_MS = 27 * 60 * 1000 + 34 * 1000;
      const newExpiresAt = new Date(Date.now() + DURATION_RENEW_MS).toISOString();
      setCookie(COOKIE_NAME, JSON.stringify({ expiresAt: newExpiresAt }), newExpiresAt);
      dispatchCountdown(newExpiresAt);
      return;
    }
    // Comportement normal (auto)
    const nowMs = Date.now();
    const status = { expired: true, state: "evergreen", expiresAtISO: new Date(nowMs).toISOString(), expiresMs: nowMs };
    let firstVisitAt = null;
    if (CURRENT_FP_ID) {
      const cached = readCache(CURRENT_FP_ID) || { fpId: CURRENT_FP_ID };
      firstVisitAt = cached.firstVisitAt || null;
      writeCache({ ...cached, state: "evergreen", expMs: nowMs, expiresAt: status.expiresAtISO, subscribed: true });
      }
      applyStateAndSideEffects(status, firstVisitAt);
    } catch {}
  });

  document.addEventListener("vx:subscribe", (e) => {
    try {
      if (CURRENT_FP_ID) {
        subscribeVisitor(CURRENT_FP_ID);
        const cached = readCache(CURRENT_FP_ID);
        if (cached) {
          writeCache({
            ...cached,
            subscribed: true
          });
          console.log("cache updated with subscribed: true");
        }
      }
    } catch (err) {
      console.error("vx:subscribe error", err);
    }
  });



 async function init() {
  // ── MODE FORCÉ EVERGREEN ──────────────────────────────────────────────
  if (LIVE_MODE === "evergreen") {
    setState("evergreen");
    await syncCartAttrIfNeeded("evergreen");
    return;
  }

  // ── MODE FORCÉ PROMO (rolling 72h, reset à chaque expiration) ─────────
  // if (LIVE_MODE === "promo") {
  //   const FORCED_KEY = "vx_forced_promo";
  //   const DURATION_H = 72;
  //   const nowMs = Date.now();

  //   let cached = null;
  //   try { cached = JSON.parse(localStorage.getItem(FORCED_KEY)); } catch {}

  //   let expiresAtISO;

  //   if (cached?.expiresAt && new Date(cached.expiresAt).getTime() > nowMs) {
  //     // Timer en cours → on réutilise
  //     expiresAtISO = cached.expiresAt;
  //   } else {
  //     // Expiré ou premier passage → on repart pour 72h depuis maintenant
  //     expiresAtISO = new Date(nowMs + DURATION_H * 60 * 60 * 1000).toISOString();
  //     try {
  //       localStorage.setItem(FORCED_KEY, JSON.stringify({ expiresAt: expiresAtISO }));
  //     } catch {}
  //   }

  //   setState("promo");
  //   await syncCartAttrIfNeeded("promo");
  //   dispatchCountdown(expiresAtISO);
  //   return;
  // }
  if (LIVE_MODE === "promo") {
    const COOKIE_NAME = "vx_forced_promo";
    const DURATION_FIRST_MS = 168 * 60 * 60 * 1000;
    const DURATION_RENEW_MS = 27 * 60 * 1000 + 34 * 1000;
    const nowMs = Date.now();

    const raw = getCookie(COOKIE_NAME);
    let cached = null;
    try { cached = raw ? JSON.parse(raw) : null; } catch {}

    let expiresAtISO;

    if (cached?.expiresAt && new Date(cached.expiresAt).getTime() > nowMs) {
      // Cookie valide → on réutilise
      expiresAtISO = cached.expiresAt;
    } else if (!cached) {
      // Première visite → 72h
      expiresAtISO = new Date(nowMs + DURATION_FIRST_MS).toISOString();
      setCookie(COOKIE_NAME, JSON.stringify({ expiresAt: expiresAtISO }), expiresAtISO);
    } else {
      // Expiré → 27min34s
      expiresAtISO = new Date(nowMs + DURATION_RENEW_MS).toISOString();
      setCookie(COOKIE_NAME, JSON.stringify({ expiresAt: expiresAtISO }), expiresAtISO);
    }

    setState("promo");
    await syncCartAttrIfNeeded("promo");
    dispatchCountdown(expiresAtISO);
    return;
  }

  // ── MODE AUTO (comportement fingerprint existant) ──────────────────────
  const fpId = await getFingerprint();
  if (!fpId) return;

  CURRENT_FP_ID = fpId;

  const duration = settings.duration ?? "midnight";
  const nowMs = Date.now();

  const cached = readCache(fpId);
  if (cached?.firstVisitAt) {
    const status = getPromoStatus(cached.firstVisitAt, duration, nowMs);
    writeCache({
      ...cached,
      expiresAt: status.expiresAtISO,
      expMs: status.expiresMs,
      state: status.state,
    });
    await applyStateAndSideEffects(status, cached.firstVisitAt);
    return;
  }

  const db = await fetchVisitor(fpId);
  const v = db?.visitor || db;

  if (v?.firstVisitAt) {
    const firstVisitISO = new Date(v.firstVisitAt).toISOString();
    const expiresISO = v.expiresAt
      ? new Date(v.expiresAt).toISOString()
      : getPromoStatus(firstVisitISO, duration, nowMs).expiresAtISO;
    const expiresMs = new Date(expiresISO).getTime();
    const expired = expiresMs <= nowMs;
    const status = { expired, state: expired ? "evergreen" : "promo", expiresAtISO: expiresISO, expiresMs };

    writeCache({ fpId, firstVisitAt: firstVisitISO, expiresAt: status.expiresAtISO, expMs: status.expiresMs, state: status.state, subscribed: v.subscribed || false });
    await applyStateAndSideEffects(status, firstVisitISO);
    return;
  }

  const firstVisitISO = new Date().toISOString();
  const status = getPromoStatus(firstVisitISO, duration, nowMs);
  createVisitor(fpId, firstVisitISO, status.expiresAtISO).catch(() => {});
  writeCache({ fpId, firstVisitAt: firstVisitISO, expiresAt: status.expiresAtISO, expMs: status.expiresMs, state: status.state });
  await applyStateAndSideEffects(status, firstVisitISO);
}
  init().finally(() => {
    dispatchVisitorReady();
  });
})();